import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  permissions: [],
  loading: false,
  error: null,
};

export const accessManagementSlice = createSlice({
  name: "access",
  initialState,
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    updatePermissions: (state, action) => {
      
      if (state.permissions && action.payload) {
        state.permissions = {
          ...state.permissions,
          ...action.payload
        };
      }
    },
    clearPermissions: (state) => {
      state.permissions = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const { setPermissions, updatePermissions, clearPermissions } = accessManagementSlice.actions;
export default accessManagementSlice.reducer;